import { Component } from '@angular/core';

@Component({
	selector: 'notifications-wrapper',
	templateUrl: './notifications-wrapper.component.html'
})
export class NotificationsWrapperComponent {
	navLinks = [
		{
			url: 'log',
			label: 'Log',
			iconClass: 'fa fa-envelope-o'
		},
		{
			url: 'templates',
			label: 'Templates',
			iconClass: 'fa fa-file-text-o'
		}
	];
}
